module.exports = __webpack_public_path__ + "static/media/screen6.616c50a5.png";